/* The `Język` tab's body: the heading (the host's skin), the segmented choice, and its one note.
 * The choice is `shared/ui/segmented`'s groove unchanged; only the column around it is here. */

.language {
  display: flex;
  flex-direction: column;
  gap: var(--space-9px);
  align-items: flex-start;
}

.note {
  margin: var(--space-0);
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-hint-dense);
  color: var(--text-2);
}
